import { Sparkles, Send } from "lucide-react";

const messages = [
  {
    from: "bot",
    text: "Hoi Sanne! 👋 Ik help je vandaag verder met je studiekeuze. Waar loop je tegenaan?",
  },
  {
    from: "user",
    text: "Ik twijfel tussen zorg en techniek 😅",
  },
  {
    from: "bot",
    text: "Slim dat je dit deelt! Uit je interessetest kwam een sterke voorkeur voor 'mensen helpen'. Zullen we opleidingen bekijken die zorg én techniek combineren?",
  },
  {
    from: "user",
    text: "Ja, goed idee!",
  },
];

const MobileChatMockup = () => {
  return (
    <div className="w-[220px] sm:w-[248px] rounded-[2.2rem] border-[6px] border-secondary/90 bg-secondary/90 shadow-large overflow-hidden select-none">
      <div className="rounded-[1.7rem] overflow-hidden bg-background">
        {/* status bar / header */}
        <div className="bg-gradient-to-r from-primary to-[hsl(212,90%,55%)] px-4 pt-3 pb-3 text-primary-foreground">
          {/* notch */}
          <div className="mx-auto mb-2 h-1 w-14 rounded-full bg-primary-foreground/40" />
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-full bg-primary-foreground/20 flex items-center justify-center">
              <Sparkles className="w-4 h-4" />
            </div>
            <div className="leading-tight">
              <div className="text-[12px] font-extrabold">Studiecoach</div>
              <div className="flex items-center gap-1 text-[9px] text-primary-foreground/80">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-300" />
                Altijd online
              </div>
            </div>
          </div>
        </div>

        {/* chat body */}
        <div className="p-3 space-y-2.5 bg-muted/40 min-h-[280px]">
          {messages.map((m, i) => (
            <div
              key={i}
              className={`flex ${m.from === "user" ? "justify-end" : "justify-start"}`}
            >
              <div
                className={`max-w-[80%] rounded-2xl px-3 py-2 text-[10.5px] leading-snug shadow-soft ${
                  m.from === "user"
                    ? "bg-primary text-primary-foreground rounded-br-sm"
                    : "bg-card text-secondary rounded-bl-sm border border-border"
                }`}
              >
                {m.text}
              </div>
            </div>
          ))}

          {/* typing indicator */}
          <div className="flex justify-start">
            <div className="bg-card border border-border rounded-2xl rounded-bl-sm px-3 py-2.5 flex items-center gap-1 shadow-soft">
              <span className="w-1.5 h-1.5 rounded-full bg-muted-foreground/50 animate-bounce [animation-delay:-0.3s]" />
              <span className="w-1.5 h-1.5 rounded-full bg-muted-foreground/50 animate-bounce [animation-delay:-0.15s]" />
              <span className="w-1.5 h-1.5 rounded-full bg-muted-foreground/50 animate-bounce" />
            </div>
          </div>
        </div>

        {/* input bar */}
        <div className="flex items-center gap-2 px-3 py-2.5 bg-card border-t border-border">
          <div className="flex-1 h-7 rounded-full bg-muted border border-border flex items-center px-3 text-[10px] text-muted-foreground">
            Typ een bericht…
          </div>
          <div className="w-7 h-7 rounded-full bg-primary flex items-center justify-center shrink-0">
            <Send className="w-3.5 h-3.5 text-primary-foreground" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileChatMockup;
